export default __webpack_public_path__ + "static/media/gallery-7.0f5c7c7b.png";